<script>
import Footer from "@/components/Footer";
  export default {
    components: {
        Footer
    },
  data() {
    return {
      isSticky: false,
      stickyClass: 'is_sticky',
      scrollPosition:0,
      visible: true,
    }
  },
  created () {
        try {
          this.checked=localStorage.getItem("mode")==='false'? true: false;
        } catch(e) {
          this.checked=false;
        }
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  },  
  methods:{
    handleScroll(){
      this.scrollPosition = window.scrollY
      if(this.scrollPosition>=50){
          this.isSticky=true
      }else{
          this.isSticky=false
      }
    },
    
  },
  
}
</script>

<style scoped>
.navbar-custom {
  font-size: 2rem;
  font-weight: 700;
  background:#fff;
  box-shadow: 0 0 21px rgb(0 0 0 / 20%);
  position: relative;
  z-index: 9;
  padding: 10px;
}
.navbar-custom.isSticky {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
  width: 100%;
  /* width: calc(100% - 320px); */
   -webkit-transition: all 0.4s ease;
  transition: all 0.4s ease;
  /* -webkit-animation: .95s ease-in-out 0s normal none 1 running fadeInDown;
  animation: .95s ease-in-out 0s normal none 1 running fadeInDown;
  -webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1); */
}
.darkmode .navbar-custom.isSticky{
  background-color: #180f4f !important;
  border-color: #180f4f !important;
  top: -24px;
  transform: translateY(24px);
  transition: transform .4s;
}
.darkmode .navbar-custom, 
.darkmode .navbar-light, 
.darkmode .navbar{
  background:#1E2041!important;
}
.darkmode .navbar-custom .light-logo, 
.darkmode .navbar-light .light-logo, 
.darkmode .navbar .light-logo, .dark-logo{
  display: none;
}
.darkmode .navbar-custom .dark-logo, 
.darkmode .navbar-light .dark-logo, 
.darkmode .navbar .dark-logo{
  display: block;
}
.navbar-logo a img{
  max-height: 80px;
}
.frequently-questions-accordion > .card > .card-header > .btn::after{
    display: none;
}
@media screen and (max-width: 768px) {
   .navbar-custom {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
}
.navbar-logo a img, 
    .navbar-logo img, 
    .navbar-logo-customer img, 
    .navbar-logo-customer a img {
        max-height: 60px;
        min-height: 60px;
    }
}

</style>

<template>

<!-- <div :class="{'d-none':page!='Blog'}"> -->
<div class="darkmode">

<div class="navbar-custom" :class="{'isSticky':isSticky}" toggleable="lg" id="#navbar">
    <b-container>
        <b-row class="align-items-center">
            <b-col sm="12" md="4" class="text-center text-lg-left">  
                <router-link to="/" class="btn btn-secondary btn-sm">
                    <i class="fas fa-angle-left"></i>
                    Back to Home
               </router-link>
               <!--<b-button @click="$parent.changePage('main')"  class="btn btn-secondary btn-sm">
                    <i class="fas fa-angle-left"></i>
                    Back to Home
               </b-button> -->
            </b-col>
            <b-col sm="12" md="4">
            <div class="navbar-logo customer-logo text-center">
                  <a class="d-inline-block" href="https://spendid.io">
                     <img alt="logo" src="logov.png" class="light-logo" />
                    <img alt="logo" src="logo-darkv.png" class="dark-logo"/> 
                  </a>
              </div>
            </b-col>
            <b-col sm="12" md="4"></b-col>
        </b-row>
    </b-container>
</div>
<section id="live-demo">
    <b-container id="faq" class="mt-3">
        <b-row>
            <b-col sm="12" xl="12">
                <div class="frequently-questions-accordion">
                    <b-card no-body class="border-none card-shadow mb-3">
                        <b-card-header header-tag="header" class="border-none shadow-none p-0">
                            <b-button block>
                            Frequently Asked Questions
                            </b-button>
                        </b-card-header>
                        <b-card-body>
                            <b-row>
                                <b-col md="12" xl="12">
                                <div class="faq-accordion" accordion role="tablist">
                                    <b-card no-body border-none shadow-none class="mb-2 mb-lg-3">
                                    <b-card-header header-tag="header" class="p-0" role="tab">
                                        <b-button  block v-b-toggle.faqaccordion-1>
                                             What is the SPENDiD web application?
                                        </b-button>
                                    </b-card-header>
                                    <b-collapse id="faqaccordion-1" v-model="visibleFaqOne" accordion="my-accordion" role="tabpanel">
                                        <b-card-body>
                                            <b-card-text>
                                                SPENDiD is a radically simple way to clearly understand a household’s current or projected cash-flow health based on proven spending and saving behaviors of its demographic peers. Plus, SPENDiD can literally help create a personalized, fully categorized budget in a matter of minutes.
                                            </b-card-text>
                                        </b-card-body>
                                    </b-collapse>
                                    </b-card>

                                    <b-card no-body border-none shadow-none class="mb-2 mb-lg-3">
                                    <b-card-header header-tag="header" class="p-0" role="tab">
                                        <b-button block v-b-toggle.faqaccordion-2>
                                            Why should I use SPENDiD? 
                                        </b-button>
                                    </b-card-header>
                                    <b-collapse id="faqaccordion-2" v-model="visibleFaqTwo" accordion="my-accordion" role="tabpanel">
                                        <b-card-body>
                                            <b-card-text>
                                                Our extensive research into the psychology of spending behavior and budget stress confirms that simplicity, clear awareness and peer validation are key to changing or further improving a household’s cash-flow habits. Think of SPENDiD as the Google Maps of Cash Flow Planning. Leading edge technology and accumulated data of thousands of people like you who have “been there and done that” make it easy for users to benefit from a set of clear directions for their personalized budget plan – much like a set of travel directions is based on where you are, where you want to go, and how you’re going to get there. 
                                            </b-card-text>
                                        </b-card-body>
                                    </b-collapse>
                                    </b-card>

                                    <b-card no-body border-none shadow-none class="mb-2 mb-lg-3">
                                    <b-card-header header-tag="header" class="p-0" role="tab">
                                        <b-button block v-b-toggle.faqaccordion-3>
                                            What makes SPENDiD different from other Cash Flow Planning apps? 
                                        </b-button>
                                    </b-card-header>
                                    <b-collapse id="faqaccordion-3" v-model="visibleFaqThree" accordion="my-accordion" role="tabpanel">
                                        <b-card-body>
                                            <b-card-text>
                                                SPENDiD’s difference is its radically simple “Predictive” approach to financial wellness and Cash Flow Planning. We takeyour readily known demographic and core spending information and let data and technology do the hard work for you. SPENDiD doesn’t hand you a spreadsheet template and wish you luck filling in an overwhelming and stressful amount of information. Tell SPENDiD a few easily known things about your household and enjoy the clarity and peace of mind you’ll receive in return.
                                            </b-card-text>
                                        </b-card-body>
                                    </b-collapse>
                                    </b-card>

                                    <b-card no-body border-none shadow-none class="mb-2 mb-lg-3">
                                    <b-card-header header-tag="header" class="p-0" role="tab">
                                        <b-button 
                                        block
                                        v-b-toggle.faqaccordion-4
                                        >
                                        Does SPENDiD connect to my bank and credit card accounts in order to work?
                                        </b-button>
                                    </b-card-header>
                                    <b-collapse id="faqaccordion-4" v-model="visibleFaqFour" accordion="my-accordion" role="tabpanel">
                                        <b-card-body>
                                        <b-card-text>
                                            No. This version of SPENDiD works much more simply than that. We’ve done the hard work for you already by assembling the peer data and algorithms that drive the SPENDiD platform. You probably won’t need a single bank statement, spreadsheet, or pen and paper to benefit from SPENDiD’s guidance and insight into your cash-flow health awareness and “Done For You” budget.
                                        </b-card-text>
                                        </b-card-body>
                                    </b-collapse>
                                    </b-card>

                                    <b-card no-body border-none shadow-none class="mb-2 mb-lg-3">
                                    <b-card-header header-tag="header" class="p-0" role="tab">
                                        <b-button 
                                        block
                                        v-b-toggle.faqaccordion-5
                                        >
                                        What does SPENDiD do with my information?
                                        </b-button>
                                    </b-card-header>
                                    <b-collapse id="faqaccordion-5" v-model="visibleFaqFive" accordion="my-accordion" role="tabpanel">
                                        <b-card-body>
                                        <b-card-text>
                                            SPENDiD will never sell or expose any personally identifiable information of any user of the application. SPENDiD uses only anonymized summary information to continually improve our user platform, data and algorithms to make sure you always receive the most accurate and stress-free financial wellness experience.
                                        </b-card-text>
                                        </b-card-body>
                                    </b-collapse>
                                    </b-card>

                                    <b-card no-body border-none shadow-none class="mb-2 mb-lg-3">
                                    <b-card-header header-tag="header" class="p-0" role="tab">
                                        <b-button 
                                        block
                                        v-b-toggle.faqaccordion-6
                                        >
                                        How often should I visit the SPENDiD web application? 
                                        </b-button>
                                    </b-card-header>
                                    <b-collapse id="faqaccordion-6" v-model="visibleFaqSeven" accordion="my-accordion" role="tabpanel">
                                        <b-card-body>
                                        <b-card-text>
                                            Of course, we’d love to see you every day! But realistically it makes sense to engage with SPENDiD at least a few times each month as we update our peer data often, and you’ll want to be certain you always know your latest SPENDiD Score and areas of needed focus. Plus, you’ll want to use SPENDiD for “what-if” scenarios related to key milestones such as a potential move, purchase of a home or car, or when making a rent vs buy decision.
                                        </b-card-text>
                                        </b-card-body>
                                    </b-collapse>
                                    </b-card>
                                    <b-card no-body border-none shadow-none class="mb-2 mb-lg-3">
                                    <b-card-header header-tag="header" class="p-0" role="tab">
                                        <b-button 
                                        block
                                        v-b-toggle.faqaccordion-7
                                        >
                                        Can I use SPENDiD on my mobile device?
                                        </b-button>
                                    </b-card-header>
                                    <b-collapse id="faqaccordion-7" v-model="visibleFaqEight" accordion="my-accordion" role="tabpanel">
                                        <b-card-body>
                                        <b-card-text>
                                            Yes! SPENDiD is built for mobile or desktop use with equal user experience elegance.
                                        </b-card-text>
                                        </b-card-body>
                                    </b-collapse>
                                    </b-card>
                                    <b-card no-body border-none shadow-none class="mb-2 mb-lg-3">
                                    <b-card-header header-tag="header" class="p-0" role="tab">
                                        <b-button 
                                        block
                                        v-b-toggle.faqaccordion-8
                                        >
                                        What should I do with the information SPENDiD gives me?
                                        </b-button>
                                    </b-card-header>
                                    <b-collapse id="faqaccordion-8" v-model="visibleFaqNine" accordion="my-accordion" role="tabpanel">
                                        <b-card-body>
                                        <b-card-text>
                                            The first thing you should do with the information SPENDiD offers is breathe easier knowing you’ve eliminated a LOT of uncertainty. If you’re having a lot of stress due to difficulty making ends meet, SPENDiD helps point you to why, and what you can focus on to address your personalized situation.
                                        </b-card-text>
                                        </b-card-body>
                                    </b-collapse>
                                    </b-card>

                                    <b-card no-body border-none shadow-none class="mb-2 mb-lg-3">
                                    <b-card-header header-tag="header" class="p-0" role="tab">
                                        <b-button 
                                        block
                                        v-b-toggle.faqaccordion-9
                                        >
                                        I’m not having trouble making ends meet - why do I need SPENDiD?
                                        </b-button>
                                    </b-card-header>
                                    <b-collapse id="faqaccordion-9" v-model="visibleFaqTen" accordion="my-accordion" role="tabpanel">
                                        <b-card-body>
                                        <b-card-text>
                                            If you’re already making ends meet, SPENDiD can offer a personalized Predicted Savings Ability (PSA) amount that you can have confidence in, and perhaps even automate as a transfer to a savings or investment account. There’s enormous power in receiving validating assurance that a targeted savings amount is right for you.
                                        </b-card-text>
                                        </b-card-body>
                                    </b-collapse>
                                    </b-card>

                                    <b-card no-body border-none shadow-none class="mb-2 mb-lg-3">
                                    <b-card-header header-tag="header" class="p-0" role="tab">
                                        <b-button 
                                        block
                                        v-b-toggle.faqaccordion-10
                                        >
                                        What is the source of Peer Data information used in SPENDiD?
                                        </b-button>
                                    </b-card-header>
                                    <b-collapse id="faqaccordion-10" v-model="visibleFaqEleven" accordion="my-accordion" role="tabpanel">
                                        <b-card-body>
                                        <b-card-text>
                                            SPENDiD’s peer data is sourced using two methods of large-scale nationwide surveys conducted by the largest and most comprehensive service available for gathering such information:
                                        </b-card-text>
                                        <ul class="list-style pl-2 pl-md-5">
                                            <li>
                                                One is an Interview Survey of recurring expenditures that consumers can readily recall such as mortgage payment, rent, utilities, etc...
                                            </li>
                                            <li>
                                                Another is a Diary Survey designed to collect data on smaller, frequently purchased items such as food, clothing, household items and services, entertainment, etc...
                                            </li>
                                        </ul>
                                        <b-card-text>
                                            When combined, the data from these surveys covers the entire range of consumers’ expenditures. Even further, this data is then modified based on scheduled changes in applicable inflation, real estate and other index factors.
                                        </b-card-text>
                                        </b-card-body>
                                    </b-collapse>
                                    </b-card>

                                    <b-card no-body border-none shadow-none class="mb-2 mb-lg-3">
                                    <b-card-header header-tag="header" class="p-0" role="tab">
                                        <b-button 
                                        block
                                        v-b-toggle.faqaccordion-11
                                        >
                                        How often is the Data updated?
                                        </b-button>
                                    </b-card-header>
                                    <b-collapse id="faqaccordion-11" v-model="visibleFaqThirteen" accordion="my-accordion" role="tabpanel">
                                        <b-card-body>
                                        <b-card-text>
                                            The data is updated at least monthly to reflect cost of living and other relevant indexes, as well as being reflective of published changes in new survey responses.
                                        </b-card-text>
                                        </b-card-body>
                                    </b-collapse>
                                    </b-card>

                                    <b-card no-body border-none shadow-none class="mb-2 mb-lg-3">
                                    <b-card-header header-tag="header" class="p-0" role="tab">
                                        <b-button 
                                        block
                                        v-b-toggle.faqaccordion-12
                                        >
                                        How does SPENDiD use this Peer Data?
                                        </b-button>
                                    </b-card-header>
                                    <b-collapse id="faqaccordion-12" v-model="visibleFaqFourteen" accordion="my-accordion" role="tabpanel">
                                        <b-card-body>
                                        <b-card-text>
                                            This peer data is instantly processed through SPENDiD’s proprietary algorithms based on a user’s demographic profile, chosen fixed expenses and savings goal. This enables the SPENDiD web application and other developers leveraging the SPENDiD API to:
                                        </b-card-text>
                                        <ul class="list-style pl-2 pl-md-5">
                                            <li>
                                                Build behavioral models based on customer demographics and spending history
                                            </li>
                                            <li>
                                                Offer “crowd-validated” categorized budget recommendations
                                            </li>
                                            <li>
                                                Create more efficiently targeted and personalized marketing strategies
                                            </li>
                                            <li>
                                                Empower employers to offer an addictively simple financial wellness tool
                                            </li>
                                            <li>
                                                Give financial institutions a powerful secondary lending metric which can result in more approved loans, and early identification of potential wealth clients
                                            </li>
                                            <li>
                                                Allow our client developers to leverage the power of “relative” or “contextualized” spending intelligence to build a range of profitable applications
                                            </li>
                                        </ul>
                                        </b-card-body>
                                    </b-collapse>
                                    </b-card>
                                    <b-card no-body border-none shadow-none class="mb-2 mb-lg-3">
                                    <b-card-header header-tag="header" class="p-0" role="tab">
                                        <b-button 
                                        block
                                            v-b-toggle.faqaccordion-13
                                        >
                                        I’m a developer – can I use the SPENDiD API in my own application
                                        </b-button>
                                    </b-card-header>
                                    <b-collapse id="faqaccordion-13" v-model="visibleFaqFifteen" accordion="my-accordion" role="tabpanel">
                                        <b-card-body>
                                        <b-card-text>
                                            Yes! You can get started right away through our partner Rapid API:
                                            <a href="https://rapidapi.com/spendid-spendid-default/api/spendid/pricing" >
                                            https://rapidapi.com/spendid-spendid-default/api/spendid/pricing
                                            </a>
                                        </b-card-text>
                                        </b-card-body>
                                    </b-collapse>
                                    </b-card>
                                    </div>
                                </b-col>
                            </b-row>
                        </b-card-body>
                    </b-card> 
                </div>          
            </b-col>
        </b-row>
    </b-container> 
</section>
<Footer />

<!-- <HowTo :class="{'d-none':page=='blog'}"/> -->

</div>  

</template>